import React from 'react';

export default function About() {
  return (
    <div className="p-6">
      <h2 className="text-3xl font-bold">О нас</h2>
      <p className="mt-4 text-gray-700">
        Здесь будет подробная информация о нашей платформе для воспитателей.
      </p>
    </div>
  );
}
